import { VirtualTableProviderBase, TableRowData } from '../IVirtualTableProvider'
import { TitleDefinitionList } from '../TitleDefinition'
import { ColumnMapper, ColumnType } from '../ColumnMapper'

export interface TestTableData {
	column1: string
	column2: number
	column3: string
	column4: string
	column5: string
}
export function buildTestTableData() {
	let res: TestTableData[] = []
	for (let ii = 0; ii < 10000; ii++) {
		const item: TestTableData = {
			column1: 'Value 1',
			column2: ii,
			column3: 'Value 3',
			column4: 'Value 4',
			column5: 'Value 5'
		}
		res.push(item)
	}
	return res
}

export class TestDataTableProvider extends VirtualTableProviderBase<TestTableData> {
	columns: ColumnMapper

	constructor(rows: TestTableData[]) {
		super(rows)
		const arr: ColumnType<TestTableData>[] = [
			// ['Column 1', 'column1'],
			// ['Column 2', 'column2'],
			// ['Column 3', 'column3'],
			// ['Column 4', 'column4'],
			// ['Column 5', 'column5']
			[{ name: 'Column 1', width: '100px' }, 'column1'],
			[{ name: 'Column 2', width: '100px' }, 'column2'],
			[{ name: 'Column 3', width: '100px' }, 'column3'],
			[{ name: 'Column 4', width: '100px' }, 'column4'],
			[{ name: 'Column 5', width: '100px' }, 'column5']
		]

		this.columns = new ColumnMapper(arr)
	}
	getAllTitles() {
		return this.columns.getAllTitles()
	}
	createRow(row: TestTableData, index: number) {
		const values = this.columns.getValues(row)

		return values
	}
}
